<template src="./html/events-quiz.html"></template>

<script>
import App from '../App.vue'
import { quizFunctions } from "../components/functions";
import moreInfoForm from '../components/more-info-form.vue'

let quiz = {
    questions: [{
      text: "What does your ideal learning tool do?",
      responses: [{
          text: 'Saves me time.',
          value: '2'
        },
        {
          text: 'Offers me a new way to engage learners.',
          value: '1'
        },
        {
          text: 'Makes remote learning easy.',
          value: '0'
        },
        {
          text: 'Allows me to keep track of what’s going on.',
          value: '3'
        },
        {
          text: 'Gives more people a platform to learn.',
          value: '4'
        }
      ],
      image: require('../assets/superhero/HeroTypesQuiz-Q1.png'),
    },
    {
      text: "How do you feel about remote learning?",
      responses: [{
          text: 'I saw its potential early on!',
          value: '0'
        },
        {
          text: 'Not only am I on board, but I’ve been able to get others excited as well.',
          value: '4'
        },
        {
          text: 'I love it when it helps me accomplish things that aren’t possible face to face.',
          value: '1'
        },
        {
          text: 'I really enjoy how quickly I can get things done.',
          value: '2'
        },
        {
          text: 'I’m amazed by all the data it puts at my fingertips.',
          value: '3'
        }
      ],
      image: require('../assets/superhero/HeroTypesQuiz-Q2.png')      
    },
    {
      text: "If you had to choose an animal to represent you, which one would it be?",
      responses: [{
          text: 'Wolf',
          value: '0'
        },
        {
          text: 'Chameleon',
          value: '3'
        },
        {
          text: 'Cheetah',
          value: '2'
        },
        {
          text: 'Owl',
          value: '4'
        },
        {
          text: 'Chimpanzee',
          value: '1'
        }
      ],
      image: require('../assets/superhero/HeroTypesQuiz-Q3.png')    },
    {
    text: "Spending all day with data sounds...",
      responses: [{
          text: 'Like heaven!',
          value: '3'
        },
        {
          text: 'Fine if it doesn\'t slow me down.',
          value: '2'
        },
        {
          text: 'Good as long as I’m learning!',
          value: '1'
        },
        {
          text: 'To be honest, it’s not my cup of tea.',
          value: '0'
        },
        {
          text: 'Okay, if it’s helping others.',
          value: '4'
        }
      ],
      image: require('../assets/superhero/HeroTypesQuiz-Q4.png')    },
    {
      text: "Which phrase do you identify most strongly with?",
      responses: [{
          text: 'When people can learn on their terms, opportunities are&nbsp;endless.',
          value: '0'
        },
        {
          text: 'If everything feels under control, it\'s time to find the next&nbsp;gear.',
          value: '2'
        },
        {
          text: 'We can do great things when we work together. Let\'s make it&nbsp;happen.',
          value: '4'
        },
        {
          text: 'Step one, gather the data. Step two, make the decision.',
          value: '3'
        },
        {
          text: 'A new tool a day keeps the boredom away.',
          value: '1'
        }
      ],
      image: require('../assets/superhero/HeroTypesQuiz-Q5.png') 
    },
    {
    text: "What's the most important question in your mind when it comes to new releases?",
      responses: [{
          text: 'When can I get it?!',
          value: '1'
        },
        {
          text: 'Is it responsive?',
          value: '0'
        },
        {
          text: 'What data will it give me?',
          value: '3'
        },
        {
          text: 'How will it change learning?',
          value: '4'
        },
        {
          text: 'Will it help me move faster?',
          value: '2'
        }
      ],
      image: require('../assets/superhero/HeroTypesQuiz-Q6.png')
    },
    {
    text: "You're stuck on a desert island. What’s the one food or drink you can't go without?",
      responses: [{
          text: 'Protein Bars',
          value: '2'
        },
        {
          text: 'Almonds',
          value: '1'
        },
        {
          text: 'Coffee',
          value: '3'
        },
        {
          text: 'Sushi',
          value: '0'
        },
        {
          text: 'Pizza',
          value: '4'
        }
      ],
      image: require('../assets/superhero/HeroTypesQuiz-Q7.png')    },
    {
    text: "What excites you most about online learning?",
      responses: [{
          text: 'Always pushing the envelope with new innovations.',
          value: '1'
        },
        {
          text: 'Finding ways to work better, smarter, faster.',
          value: '2'
        },
        {
          text: 'Opening technological doors to more learners.',
          value: '0'
        },
        {
          text: 'Understanding what learners need most to help them thrive.',
          value: '3'
        },
        {
          text: 'Sparking change and using learning as a catalyst to make it happen.',
          value: '4'
        }
      ],
      image: require('../assets/superhero/HeroTypesQuiz-Q8.png')    },
  ]
};

let types_content = {

    sections: [
      {
        section_title: 'Trailblazer',
        hovered_content: 'Embracing remote learning early',
        background_colour: 'color-cinnabar-p1',
        text_colour: 'color-onyx',
        image: require('../assets/superhero/HeroTypesQuiz_Trailblazer.png'),
        social_description: 'I\'m a Trailblazer! Register for Fusion to find out what superhero you are!',
        winner_content: 'You were an early adopter⁠—a promoter of remote learning before it was cool. Now you\'re on a mission to take the wisdom you\'ve acquired and share it with the world.',
        download_pdf: ''
      },
      {
        section_title: 'Gadgeteer',
        hovered_content: 'Knowing how to use the latest tools',
        background_colour: 'color-fluorite',
        text_colour: 'd2lWhite',
        image: require('../assets/superhero/HeroTypesQuiz_Gadgeteer.png'),
        social_description: 'I\'m a Gadgeteer! Register for Fusion to find out what superhero you are!',
        winner_content: 'You love nothing more than being able to add a new tool to your utility belt. When someone has a question about what\'s coming up or how to use something, you\'re the superhero they turn to.',
        download_pdf: ''
      },
      {
        section_title: 'Speedster',
        hovered_content: 'Finding the fastest ways to do things',
        background_colour: 'color-citrine',
        text_colour: 'color-onyx',
        image: require('../assets/superhero/HeroTypesQuiz_Speedster.png'),
        social_description: 'I\'m a Speedster! Register for Fusion to find out what superhero you are!',
        winner_content: 'Efficiency is the name of the game for you. We\'ll keep this short. Your superpower is finding the best, fastest ways to get the job done.',
        download_pdf: ''
      },
      {
        section_title: 'Super Agent',
        hovered_content: 'Having an in-depth knowledge of what’s going on',
        background_colour: 'color-malachite',
        text_colour: 'color-onyx',
        image: require('../assets/superhero/HeroTypesQuiz_SuperAgent.png'),
        social_description: 'I\'m a Super Agent! Register for Fusion to find out what superhero you are!',
        winner_content: 'The name is Agent. Super Agent. The mission, which you gladly accept, is using cunning and stealth to uncover what\'s happening in your learning environment and with your learners.',
        download_pdf: ''
      },
      {
        section_title: 'Cosmic Guardian',
        hovered_content: 'Being a vocal champion for change',
        background_colour: 'color-peridot',
        text_colour: 'color-onyx',
        image: require('../assets/superhero/HeroTypesQuiz_CosmicGuardian.png'),
        social_description: 'I\'m a Cosmic Guardian! Register for Fusion to find out what superhero you are!',
        winner_content: 'Your powers to inspire others seem straight out of legend. You have an unwavering passion to transform how the world learns, and you do everything you can to make that happen.',
        download_pdf: ''
      }
    ]
};

export default {
  name: 'fusion-superhero-type-quiz',
  components: {
    moreInfoForm
  },
  data() { 
    return this.defaultQuizData() 
  },
  mixins: [quizFunctions],
  methods: {
    defaultQuizData: function () {
      return {
        name:'superhero-type',
        title: 'Which superhero are you?',
        share_description: 'Complete this quiz to find out which superhero you are!',
        active_image_default: require('../assets/superhero/HeroTypesQuiz_Hero-intro.png'),
        active_image: require('../assets/superhero/HeroTypesQuiz_Hero-intro.png'),
        active_section: '-1',
        active_colour_default: 'd2lOrange',
        active_colour: 'd2lOrange',
        winning_colour: '',
        winning_text_colour: '',
        winning_image: '',
        winning_title: '',
        content_display: '',
        quiz_hidden: true,
        quiz: quiz,
          questionIndex: 0,
          userResponses: Array(),
        homepage_hidden: false,
        types: types_content,
        share_url: 'https://www.d2l.com/events/fusion/register',
        showForm: false,
        form_text: 'Fill out the form to get the full story on your superhero—your superpower, top tools, ally, and nemesis—plus a custom background for video calls.',
        form_thank_you_message: '',
        button_text: '',
        form_id: '2289',
        salesforce_id: '7015W0000008zKWQAY',
        asset_redirect: ''
      }
    }
  }
}

</script>